import { useEffect } from "react";
import CollapsibleSection from "@components/common/Section/CollapsibleSection";
import Button from "@components/common/Button";
import Checkbox from "@components/common/Checkbox";
import {
	global as global_permissions,
	Permission,
} from "@components/Auth/permissions";
import { useAuth } from "@/app/hooks/useAuth";
import { useUserPermissions } from "./UserPermissionsContext.jsx";
import Badge from "@/app/components/common/Badge";

function UserGlobalPermissions({ userId, userPermissions }) {
	const { user: authUser, checkPermissions } = useAuth();
	const { uwr } = authUser || {};
	const sealord = checkPermissions("none", Permission.SEALORD, false);
	const {
		selectedPermissionSet,
		permissionSets,
		user,
		globalPermissions,
		setGlobalPermissions,
		saveAllPermissions,
	} = useUserPermissions();

	useEffect(() => {
		const preset =
			selectedPermissionSet &&
			permissionSets[selectedPermissionSet]?.preset;

		const mappedPermissions = global_permissions.map((p) => {
			// If there's a preset, use it to determine checked state
			// Otherwise, use the user's existing permissions
			const checked =
				(userPermissions || []).length === 0 && preset
					? preset.includes(p.key)
					: !!userPermissions.find(
							(x) =>
								x.organisation_id === null && x.type === p.key
						);

			return {
				checked,
				key: p.key,
				label: p.label,
				uwr: p.uwr,
				sealord: p.sealord,
			};
		});
		setGlobalPermissions(mappedPermissions);
	}, [
		userPermissions,
		user.uwr,
		selectedPermissionSet,
		permissionSets,
		setGlobalPermissions,
	]);

	const canEditPermission = (permission) => {
		if (permission.sealord) {
			return sealord;
		}
		if (permission.uwr) {
			return uwr;
		}
		return false;
	};

	const handleToggle = (key) => {
		const permission = globalPermissions.find((p) => p.key === key);
		if (!permission || !canEditPermission(permission)) {
			return;
		}
		setGlobalPermissions((prev) =>
			prev.map((p) => (p.key === key ? { ...p, checked: !p.checked } : p))
		);
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (!globalPermissions.some(canEditPermission)) {
			return;
		}
		await saveAllPermissions();
	};

	return (
		<CollapsibleSection title="Global Permissions">
			<form onSubmit={handleSubmit} className="space-y-4">
				<input type="hidden" name="user_id" value={userId} />

				<div className="space-y-2">
					{globalPermissions
						// .filter((p) => ((p.uwr && uwr) || !p.uwr) && ((p.sealord && sealord) || !p.sealord))
						.map((perm) => (
							<div
								key={perm.key}
								className="flex items-center gap-2"
							>
								<Checkbox
									label={`${perm.label}`}
									name={perm.key}
									checked={perm.checked}
									onChange={() => handleToggle(perm.key)}
									controlled={true}
									disabled={!canEditPermission(perm)}
								/>
								{permissionSets[
									selectedPermissionSet
								]?.preset?.includes(perm.key) && (
									<Badge
										variant="the-brown"
										size="sm"
										rounded
									>
										Default permission
									</Badge>
								)}
							</div>
						))}
				</div>
				{globalPermissions.some(canEditPermission) && (
					<Button type="submit" variant="primary">
						Save
					</Button>
				)}
			</form>
		</CollapsibleSection>
	);
}
export default UserGlobalPermissions;
